<template>
  <div>
    <page-section bgcolor="bg-white">
      <section-heading pre="Contact Us">Get in Touch</section-heading>
      <contact-form />
      
    </page-section>
  </div>
</template>
    <script>
import SectionHeading from "@/components/SectionHeading";
import PageSection from "@/components/PageSection";
import ContactForm from "@/components/ContactForm";

export default {
  components: {
    SectionHeading,
    PageSection,
    ContactForm
  },
};
</script>
              
  